// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EWQ1","right":"styles_right__2qtc_"};